import React, { useState, useEffect } from 'react';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';

import { FaPlus, FaRegSave, FaTimes, FaTrashAlt } from 'react-icons/fa';

const PerguntaModal = ({ pergunta, onClose, onPerguntaAtualizada }) => {
    const [tituloModal, setTituloModal] = useState("");
    const [formData, setFormData] = useState({
        ds_enunciado: '',
        tp_pergunta: '',
        multipla_escolha: true,
        respostas: []
    });

    const [respostasExcluidas, setRespostasExcluidas] = useState([]);

    useEffect(() => {
        if (pergunta != null) {
            setFormData({
                ...pergunta
            });
            setTituloModal('Editar Pergunta');
        }
        else setTituloModal('Nova Pergunta');
    }, [pergunta]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const camposObrigatorios = [
            { campo: 'ds_enunciado', label: 'Enunciado' },
            { campo: 'tp_pergunta', label: 'Tipo' },
        ];

        const camposInvalidos = camposObrigatorios.filter(({ campo }) => !formData[campo]?.trim());

        if (camposInvalidos.length > 0) {
            Swal.fire(
                'Erro',
                `Os seguintes campos são obrigatórios: ${camposInvalidos.map(c => c.label).join(', ')}`,
                'error'
            );
            return;
        }

        if (formData.tp_pergunta === '02' || formData.tp_pergunta === '03' || formData.tp_pergunta === '04') {
            const validarRespostas = formData.respostas.filter(item => item.ds_resposta.trim() === '');
            if (formData.respostas.length == 0 || validarRespostas.length > 0) {
                Swal.fire('Erro', 'Por favor, preencha as respostas da pergunta.', 'error');
                return;
            }
        }

        let novasRespostas = formData.respostas.filter(item => item.id === null);
        novasRespostas = novasRespostas.map(item => item.ds_resposta);
        delete formData.respostas;

        let respostasRemovidas = respostasExcluidas.filter(item => item.id !== null) || [];
        const data = {
            pergunta: formData,
            novasRespostas: novasRespostas,
            respostasExcluidas: respostasRemovidas.map(item => item.id)
        };
        
        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (pergunta != null) {
                await api.put(`/anamnese-perguntas/${pergunta.id}`, data);
            }
            else {
                await api.post(`/anamnese-perguntas`, data);
            }

            onPerguntaAtualizada();
            onClose();
            Swal.fire('Sucesso', 'Pergunta salva com sucesso!', 'success');
        }
        catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
    };

    const handleInputChange = (index, value) => {
        const updatedRespostas = [...formData.respostas];
        updatedRespostas[index].ds_resposta = value;
        setFormData({ ...formData, respostas: updatedRespostas });
    };

    const handleAddResposta = () => {
        const newResposta = {
            id: null,
            id_Pergunta: 10,
            ds_resposta: "",
            criado_por: null,
            criado_em: new Date().toISOString(),
            alterado_por: null,
            alterado_em: null
        };
        setFormData({
            ...formData,
            respostas: [...formData.respostas, newResposta],
        });
    };

    const handleRemoveResposta = (index) => {
        const removedResposta = formData.respostas[index];
        const updatedRespostas = formData.respostas.filter((_, i) => i !== index);

        setFormData({ ...formData, respostas: updatedRespostas });
        setRespostasExcluidas([...respostasExcluidas, removedResposta]);
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Enunciado</label>
                                    <input
                                        type="text"
                                        name="ds_enunciado"
                                        autoComplete="off"
                                        className="form-control"
                                        value={formData.ds_enunciado}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Tipo</label>
                                    <select
                                        name="tp_pergunta"
                                        className="form-control"
                                        value={formData.tp_pergunta}
                                        onChange={handleChange}
                                    >
                                        <option value="" hidden>Selecione...</option>
                                        <option value="01">Texto</option>
                                        <option value="02">Múltipla Escolha</option>
                                        <option value="03">Escolha Única</option>
                                        <option value="04">Caixa de Seleção</option>
                                        <option value="05">Área de Texto</option>
                                        <option value="06">Arquivo</option>
                                        <option value="07">Faixa de Valores</option>
                                    </select>
                                </div>
                            </div>
                            {(formData.tp_pergunta === '02' || formData.tp_pergunta === '03' || formData.tp_pergunta === '04') && (
                                <div className="row mt-3">
                                    <div className="col-12 max-h-400 overflow-y-auto">
                                        <div className="d-flex mb-2 justify-content-between align-items-end">
                                            <label className="form-label fw-bold">Respostas</label>
                                            <button type="button" className="btn btn-primary mt-2" onClick={handleAddResposta}>
                                                <FaPlus />
                                            </button>
                                        </div>
                                        {formData.respostas.map((resposta, index) => (
                                            <div key={index} className="d-flex align-items-center mb-2">
                                                <input
                                                    type="text"
                                                    className="form-control me-2"
                                                    value={resposta.ds_resposta}
                                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                                    disabled={resposta.id !== null}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => handleRemoveResposta(index)}
                                                >
                                                    <FaTrashAlt />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </form>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default PerguntaModal;
